import { Box } from '@material-ui/core';
import { DocumentStatus } from '@nemuru-eng/js-api-client';
import { useEffect, useMemo, useState } from 'react';

import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { PendingDocumentsSection } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/UploadDocuments/components/PendingDocumentsSection';
import { UploadedDocumentsSection } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/UploadDocuments/components/UploadedDocumentsSection';
import { CustomAlert } from '@/components/shared/components/CustomAlert';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { StyledAccordion } from '@/components/shared/components/StyledAccordion';
import { Text } from '@/components/shared/components/Text';

const PENDING_DOCUMENT_STATUS = [DocumentStatus.PENDING, DocumentStatus.INCIDENCE];

interface NextActionUploadDocumentsProps {
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}

export const NextActionUploadDocuments = ({ paymentMethodDetailEntity }: NextActionUploadDocumentsProps) => {
  const requiredFiles = useMemo(() => paymentMethodDetailEntity.allRequiredFiles, [paymentMethodDetailEntity]);
  const [isDocumentationUploaded, setIsDocumentationUploaded] = useState<boolean | null>(null);

  useEffect(() => {
    paymentMethodDetailEntity.isBorrowerDocumentationUploaded().then((isUploaded) => {
      setIsDocumentationUploaded(isUploaded);
    });
  }, [paymentMethodDetailEntity]);

  if (isDocumentationUploaded === null) {
    return null;
  }

  if (isDocumentationUploaded || !requiredFiles || !requiredFiles.length) {
    return <CustomAlert title={'ALL_DOCUMENTS_UPLOADED'} severity="success" />;
  }

  const pendingFiles = requiredFiles.filter((requiredFile) => PENDING_DOCUMENT_STATUS.includes(requiredFile.status));

  const uploadedFiles = requiredFiles.filter((requiredFile) => !PENDING_DOCUMENT_STATUS.includes(requiredFile.status));

  return (
    <FlexColumn gridGap={16} justifyContent={'center'} width={'100%'}>
      <PendingDocumentsSection files={pendingFiles} paymentMethodDetailEntity={paymentMethodDetailEntity} />
      <Box width={'100%'} mt={2}>
        <StyledAccordion.Accordion>
          <StyledAccordion.AccordionSummary
            style={{ marginTop: '0', display: 'flex', alignItems: 'center', height: '24px' }}
            expandIcon={
              <Font variant="caption" color="textSecondary" style={{ display: 'flex' }}>
                <Icon>expand_more</Icon>
              </Font>
            }
          >
            <FlexRow justifyContent={'flex-end'} width={'100%'}>
              <Font variant="body2" color="textPrimary" align="right">
                <Text tId={'UPLOADED_DOCUMENTS'} /> ({uploadedFiles.length})
              </Font>
            </FlexRow>
          </StyledAccordion.AccordionSummary>
          <StyledAccordion.AccordionDetails>
            <Box margin={1} width={'100%'}>
              <UploadedDocumentsSection files={uploadedFiles} paymentMethodDetailEntity={paymentMethodDetailEntity} />
            </Box>
          </StyledAccordion.AccordionDetails>
        </StyledAccordion.Accordion>
      </Box>
    </FlexColumn>
  );
};
